export class ExportPackageRequest {
    id: string;
    referenceType: number;
    pageSize: number;
    leftMarginInches: number;
    roomSystemsMatrix: boolean;
    roomSummarySheets: boolean;
    revitModels: boolean;
    applicableStandards: boolean;
    associatedDocuments: boolean;
}